/* eslint-disable camelcase */
import React from 'react';
import { getInlineCommentMode } from 'selectors/envelopeReview';
import { useSelector } from 'store';

export type SummaryTagType = 'reduced-all' | 'reduced-some' | 'high-risk' | 'none';

type ComponentProps = {
  type: SummaryTagType;
};

const SummaryTag: React.FC<ComponentProps> = ({ type }) => {
  const inlineCommentMode = useSelector(getInlineCommentMode);

  const styledTextMap: Record<SummaryTagType, JSX.Element | null> = {
    'reduced-all': (
      <span
        className={`rounded-sm py-0.5 px-1 ${
          inlineCommentMode ? 'bg-litlingo-gray-1' : 'bg-litlingo-success-light'
        }`}
      >
        <b>Edited: </b> Reduced risk for all matches
      </span>
    ),
    'reduced-some': (
      <span
        className={`rounded-sm py-0.5 px-1 ${
          inlineCommentMode ? 'bg-litlingo-gray-1' : 'bg-litlingo-success-light'
        }`}
      >
        <b>Edited: </b> Reduced risk for some matches
      </span>
    ),
    'high-risk': (
      <span
        className={`rounded-sm py-0.5 px-1 ${
          inlineCommentMode ? 'bg-litlingo-gray-1' : 'bg-litlingo-alert-light'
        }`}
      >
        Sent with high risk
      </span>
    ),
    none: null,
  };

  return <div className="flex rounded-sm text-small">{styledTextMap[type]}</div>;
};

export default SummaryTag;
